import { CmsLogosBlockLoadable } from './CmsLogosBlockLoadable';

import type { CmsApiLogosBlockData } from '#/modules/cms/api/types/blocks/CmsApiLogosBlock';
import type { CmsBlockMapping } from '#/modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from '#/modules/cms/mappers/CmsMappedBlockWidth';

export const CmsLogosBlockMapping: CmsBlockMapping<CmsApiLogosBlockData> = {
  invariant: [],
  width: CmsMappedBlockWidth.NARROW,
  Component: CmsLogosBlockLoadable,
};
